import { DLocalData } from '../../components/DLocal';

export const TOKEN_ERROR = 'token-error';

export class DLocalError extends Error {
  public code: number | string;

  public param: string;

  constructor({
    code,
    message,
    param,
  }: {
    code?: number;
    message: string;
    param?: string;
  }) {
    super(message);
    this.code = code || TOKEN_ERROR;
    this.param = param || '';
  }
}

function executeDLocalScript(
  dLocalData: DLocalData,
  name: string,
): Promise<{ token: string }> {
  return dLocalData.createToken(dLocalData.cardField, {
    name,
  });
}

interface CheckoutInput {
  dLocalData: DLocalData;
  cardHolder: string;
}

export async function getDLocalToken({
  dLocalData,
  cardHolder,
}: CheckoutInput) {
  return executeDLocalScript(dLocalData, cardHolder).catch(error => {
    if (error.error.message) throw new DLocalError(error.error);
    else throw error;
  });
}
